require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-from-a-site-to-a-suburb.json") })
        }
      }, "path---news-from-a-site-to-a-suburb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-from-a-site-to-a-suburb!./.cache/json/news-from-a-site-to-a-suburb.json
// module id = 813
// module chunks = 231608221292675